import { useTranslation } from 'react-i18next'
import { StyledLink } from 'baseui/link'

const FISCAL_CODE_CHECK_URL =
  'https://telematici.agenziaentrate.gov.it/VerificaCF/VerificaCfPf.do?cf=undefined&cognome=undefined&nome=undefined&data=Invalid%20date&comune=&sesso='

type FiscalCodeCheckLinkProps = {
  hidden: boolean
}

const FiscalCodeCheckLink = ({ hidden }: FiscalCodeCheckLinkProps) => {
  const { t } = useTranslation()

  if (hidden) {
    return null
  }

  return (
    <StyledLink href={FISCAL_CODE_CHECK_URL} animateUnderline target='_blank'>
      {t('subscriptionForm:customer_module.taxIdCode.check')}
    </StyledLink>
  )
}

export default FiscalCodeCheckLink
